// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb-headline":"style_breadcrumb-headline__3KdSk","margintop8px":"style_margintop8px__2VC6T","margintop11px":"style_margintop11px__39Jbe"};